import styled from 'styled-components';

export const Form = styled.form`
  max-width: 1200px;
  margin: auto;
`;
export const FlightTypesWrapper = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.x4};
`;
export const FieldsRow = styled.div`
  display: flex;
  margin: 0 ${({ theme }) => `-${theme.spacing.x2} ${theme.spacing.x5}`};
  @media (max-width: ${({ theme }) => theme.media.sm}) {
    flex-direction: column;
  }
`;
export const Field = styled.div`
  display: flex;
  padding: 0 ${({ theme }) => theme.spacing.x1};
  @media (max-width: ${({ theme }) => theme.media.sm}) {
    padding: 0 ${({ theme }) => theme.spacing.x2};
  }

  flex: 0 0 33.333%;
`;

export const DepartureArrival = styled(Field)`
  flex: 1 0 66.666%;
  @media (max-width: ${({ theme }) => theme.media.sm}) {
    margin: ${({ theme }) => theme.spacing.x2} 0;
  }
`;

export const DateFieldWrapper = styled.div`
  width: 100%;
`;
export const DateFieldContainer = styled.div`
  margin: 0 ${({ theme }) => `-${theme.spacing.x2}`};
  display: flex;
`;
export const DateField = styled.div<{ $m? }>`
  flex: auto;

  label {
    white-space: nowrap;
  }
`;
export const DateFieldParent = styled.div`
  @media (max-width: ${({ theme }) => theme.media.sm}) {
    padding: 0 ${({ theme }) => theme.spacing.x2};
  }
  width: 100%;
`;
